import { useState } from 'react';
import { subscribeUserToPush, isPushSupported } from '../services/notificationService';
import { doc, updateDoc } from 'firebase/firestore';

export default function NotificationPrompt({ userId, db, onClose, currentStatus }) {
  const [loading, setLoading] = useState(false);

  if (!isPushSupported()) return null;

  async function handleAllow() {
    setLoading(true);
    const result = await subscribeUserToPush(userId, db);
    const status = result.success ? 'subscribed' : 'permanently_declined';
    await updateDoc(doc(db, 'users', userId), { notificationPromptStatus: status });
    setLoading(false);
    onClose();
  }

  async function handleLater() {
    const nextStatus = currentStatus === 'never_asked' ? 'asked_day1'
      : currentStatus === 'asked_day1' ? 'asked_day3'
      : 'asked_day7';
    await updateDoc(doc(db, 'users', userId), { notificationPromptStatus: nextStatus });
    onClose();
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      zIndex: 1000, padding: '0 0 104px 0'
    }}>
      <div style={{
        background: '#1a1a2e', borderRadius: '16px', padding: '24px',
        width: '90%', maxWidth: '400px', textAlign: 'center'
      }}>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>🔔</div>
        <h3 style={{ color: '#ffffff', marginBottom: '8px', fontSize: '18px' }}>
          सूचना चालू करा
        </h3>
        <p style={{ color: '#aaaaaa', fontSize: '14px', marginBottom: '24px' }}>
          दररोज सकाळी सराव आठवण मिळेल
        </p>
        <button
          onClick={handleAllow}
          disabled={loading}
          style={{
            width: '100%', padding: '14px', background: '#2563eb',
            color: '#fff', border: 'none', borderRadius: '10px',
            fontSize: '16px', fontWeight: '600', marginBottom: '10px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'थांबा...' : 'हो, चालू करा'}
        </button>
        <button
          onClick={handleLater}
          style={{
            width: '100%', padding: '14px', background: 'transparent',
            color: '#aaaaaa', border: '1px solid #333', borderRadius: '10px',
            fontSize: '14px', cursor: 'pointer'
          }}
        >
          नंतर करतो
        </button>
      </div>
    </div>
  );
}